'use strict';

function TestimonialCarousel() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout, _AnalyticsData];
  this.product = '';
  this.analytics = new Analytics();
  this.el = {};
  this._classes = {
    testimonialSet: '.js--testimonial-set',
    button: 'js--carousel-button',
    loading: 'js--loading-spinner',
    loaded: 'loading-spinner--fade-out'
  };

  this.init = function () {
    this.$node = $(this.node);
    this.$node.show();
    this.el.testimonialList = this.$node.find(this._classes.testimonialSet);
    this.el.loading = this.$node.find(this._classes.loading);

    // MKTG-375: load testimonials from local snapshot. The locale-space branch that
    // previously forked on data-mogo-page-content-locale has been dropped — its
    // access tokens have been invalid in production (401), so no locale-specific
    // testimonials were actually being rendered.
    var contentfulPromise = ContentSnapshots.load('testimonial');

    // load js for slick slider
    var slickPromise = $.ajax({
      url: '/javascripts/slick.min.js',
      dataType: 'script'
    });

    $.when(contentfulPromise, slickPromise).then(this._loadContentful.bind(this)).then(this._loadCarousel.bind(this)).then(this._advanceOneSlide.bind(this)) // needed because the last slide is put in the center onload
    .then(this._pushCurrentTestimonialAnalytics.bind(this)).then(this._setSlideDimensions.bind(this));

    this.registerResponsiveFunction(this._setSlideDimensions);
  };

  this.initAllReady = function () {
    this.el.loading.addClass(this._classes.loaded);
  };

  this._loadContentful = function (contentfulData) {
    var _this = this;

    this.contentfulData = contentfulData;
    this.testimonials = this.contentfulData.items;

    // order recent testimonials first
    this.testimonials.sort(function (a, b) {
      return a.__meta.createdAt > b.__meta.createdAt;
    });

    // build testimonial slides and append to slide deck (filter based on product name)
    this.testimonials.forEach(function (item, i) {
      // if (item.category) {
      // this line should change to:
      // if (item.category.includes(this.product)) {
      // when we want to show testimonial in other product pages
      if (item.category.includes(_this.product)) {
        var slugifiedSource = item.source.replace(' ', '');
        var slugifiedRating = item.rating ? item.rating.replace('.', 'point') : '';
        _this.el.testimonialList.append('<article class="testimonials-carousel__testimonial testimonials-carousel__testimonial--' + slugifiedSource + '">\n            <h3 class="testimonials-carousel__testimonial-author">' + item.userName + '</h3>\n            <div class="testimonials-carousel__testimonial-source">' + item.source + '</div>\n            <p class="testimonials-carousel__testimonial-quote">' + item.quote + '</p>\n            <div class="testimonials-carousel__testimonial-stars testimonials-carousel__testimonial-stars--' + slugifiedRating + '"></div>\n          </article>');
      }
    });

    // make adjustments for no slides or if the set of slides fits into a resolution
    // without needing scrolling
    if (this.el.testimonialList.children().length === 0) {
      this.el.testimonialList.hide();
    } else {
      if (this.el.testimonialList.children().length > 1) {
        this.$node.addClass('testimonials-carousel--not-all-show-for-small');
      }
      if (this.el.testimonialList.children().length > 3) {
        this.$node.addClass('testimonials-carousel--not-all-show-for-large');
      }
    }

    this._onLoadingComplete();
  };

  this._loadCarousel = function () {
    var _this2 = this;

    this.el.testimonialList.slick({
      prevArrow: '<button type="button" class="testimonials-carousel__previous ' + this._classes.button + ' js--carousel-button">Previous</button>',
      nextArrow: '<button type="button" class="testimonials-carousel__next ' + this._classes.button + '">Next</button>',
      cssEase: 'ease-in-out',
      dots: this.el.testimonialList.children().length > 3,
      infinite: true,
      centerMode: this.el.testimonialList.children().length > 1,
      centerPadding: 0,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 640,
        settings: {
          dots: this.el.testimonialList.children().length > 1,
          infinite: this.el.testimonialList.children().length > 2,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '36px'
        }
      }, {
        breakpoint: 1024,
        settings: {
          dots: this.el.testimonialList.children().length > 1,
          infinite: this.el.testimonialList.children().length > 2,
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true
        }
      }]
    });

    // remove the focus/hover style if you click, but not if you are using a keyboard
    this.el.testimonialList.on('mouseup', '.' + this._classes.button, function () {
      this.blur();
    });

    // send analytics when slide changes
    this.el.testimonialList.on('afterChange', function (event, slick, currentSlide, nextSlide) {
      _this2._pushCurrentTestimonialAnalytics();
    });
  };

  this._advanceOneSlide = function () {
    this.el.testimonialList.slick('slickNext');
  };

  // adjust slides to have the same height
  this._setSlideDimensions = function () {
    var testimonialQuotes = document.querySelectorAll('.testimonials-carousel__testimonial-quote');

    // reset all heights to default
    testimonialQuotes.forEach(function (node) {
      node.style.height = 'auto';
    });

    // find highest height quote
    var longestQuoteLength = 0;
    testimonialQuotes.forEach(function (node) {
      if (node.offsetHeight > longestQuoteLength) {
        longestQuoteLength = node.offsetHeight;
      }
    });

    // set all quotes to that height
    testimonialQuotes.forEach(function (node) {
      node.style.height = longestQuoteLength + 'px';
    });
  };

  this._onLoadingComplete = function () {
    this.el.loading.remove();
  };

  this._pushCurrentTestimonialAnalytics = function () {
    var currentSlideIndex = this.el.testimonialList.slick('slickCurrentSlide');
    var currentSlideElement = this.el.testimonialList.find('[data-slick-index="' + currentSlideIndex + '"]')[0];
    if (currentSlideIndex > 0) {
      this.analytics.pushEvent('testimonial-slide-view', {
        testimonialName: [currentSlideElement.getElementsByClassName('testimonials-carousel__testimonial-author')[0].innerText],
        testimonialSource: [currentSlideElement.getElementsByClassName('testimonials-carousel__testimonial-source')[0].innerText],
        testimonialQuote: [currentSlideElement.getElementsByClassName('testimonials-carousel__testimonial-quote')[0].innerText]
      });
    }
  };
}